module.exports = __webpack_public_path__ + "54cf98f5/img/archive-icon.0a6a9de3.svg";